// extracted by mini-css-extract-plugin
export default {"body":"campaigns_body__XeP5H","container":"campaigns_container__VNwhn","icon":"campaigns_icon__-GfL5","divIcon":"campaigns_divIcon__+ixID"};